enum keyCode {
  ENTER = 'Enter',
  BACKSPACE = 'Backspace',
  ARROW_DOWN = 'ArrowDown',
  ARROW_UP = 'ArrowUp',
  TAB = 'Tab',
  ESCAPE = 'Escape',
}

export default keyCode;
